module.exports = __webpack_public_path__ + "static/media/hurricane.6530c451.svg";